var formatter = new Intl.NumberFormat('de-DE');
var formatterDigits = new Intl.NumberFormat('es', { minimumFractionDigits: 2});
var formatterDigits2 = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, useGrouping: true});



Chart.defaults.global.defaultFontFamily =
  "Inter, Helvetica, Arial, sans-serif";

Chart.pluginService.register({
  beforeRender: function (chart) {
    if (chart.config.options.showAllTooltips) {
      // create an array of tooltips
      // we can't use the chart tooltip because there is only one tooltip per chart
      chart.pluginTooltips = [];
      chart.config.data.datasets.forEach(function (dataset, i) {
        chart.getDatasetMeta(i).data.forEach(function (sector, j) {
          chart.pluginTooltips.push(
            new Chart.Tooltip(
              {
                _chart: chart.chart,
                _chartInstance: chart,
                _data: chart.data,
                _options: chart.options.tooltips,
                _active: [sector],
              },
              chart
            )
          );
        });
      });

      // turn off normal tooltips
      chart.options.tooltips.enabled = false;
    }
  },
  afterDraw: function (chart, easing) {
    if (chart.config.options.showAllTooltips) {
      // we don't want the permanent tooltips to animate, so don't do anything till the animation runs atleast once
      if (!chart.allTooltipsOnce) {
        if (easing !== 1) return;
        chart.allTooltipsOnce = true;
      }

      // turn on tooltips
      chart.options.tooltips.enabled = true;
      Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
        tooltip.initialize();
        tooltip.update();
        // we don't actually need this since we are not animating tooltips
        tooltip.pivot();
        tooltip.transition(easing).draw();
      });
      chart.options.tooltips.enabled = false;
    }
  },
});

window.chartColors = {
  primary: "#004950",
  light: "rgb(111, 194, 234)",
  lighter: "rgba(255,255,255,.6)",
  white: "#ffffff",
  dark1: "#092856",
  dark2: "rgb(10, 28, 68)",
  // grey2: "rgb(100, 123, 152)",
  // grey3: "rgb(66,85,118)",
  // grey4: "rgb(140,152,173)",
  yellow: "#F3C344",
  yellowDark: "#FE9C3B",
  yellowLight: "#F2F4A4",

  green1: "#87d4d7",
  green2: "#5a8d92",
  green3: "#32b6ba",
  grey1: "#ccd2d2",
  grey2: "#a1aeb1",
  grey3: "#859398",
};
var primary = chartColors.primary;
var light = chartColors.light;
var lighter = chartColors.lighter;
var white = chartColors.white;
var dark1 = chartColors.dark1;
var dark2 = chartColors.dark2;
var grey2 = chartColors.grey2;
var grey3 = chartColors.grey3;
var grey4 = chartColors.grey4;
var yellow = chartColors.yellow;
var yellowDark = chartColors.yellowDark;
var yellowLight = chartColors.yellowLight;
var green1 = chartColors.green1;
var green2 = chartColors.green2;
var green3 = chartColors.green3;
var grey1 = chartColors.grey1;
var grey2 = chartColors.grey2;
var grey3 = chartColors.grey3;

// HUSCV
var configHUSCV = {
  type: "horizontalBar",
  data: {
    labels: [
      "Altes hospitalàries",
      "Estades",
      "Sessions hospital de dia",
      "Total visites geriatria",
    ],
    datasets: [
      {
        backgroundColor: [
          "#8D979B",
          "#8D979B",
          "#8D979B",
          "#8D979B",
        ],
        data: [1234, 31405, 9998, 3110],
        // barThickness: "flex",
        barThickness: "30",
        // categoryPercentage: 1.0,
        // barPercentage: 0.6,
      },
    ],
  },
  options: {
    title: {
      display: false,
    },
    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          display: false,
        },
      ],
      yAxes: [
        {
          display: true,
          gridLines: {
            display: false,
          },
          ticks: {
            fontColor: "#fff",
            fontFamily: "Inter, Helvetica, Arial, sans-serif",
            fontSize: 14,
            fontStyle: "500",
          },
        },
      ],
    },
    cornerRadius: 4,
    maintainAspectRatio: false,
    responsive: true,
    showAllTooltips: true,
    tooltips: {
      //mode: 'index',
      //intersect: false,
      callbacks: {
        titleFontSize: function () {
          return 200;
        },
        label: function (tooltipItem) {
          // Format number with thousand separators (dot notation)
          return tooltipItem.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        title: function (tooltipItem) {
          return;
        },
      },
      displayColors: false,
      caretSize: 0,
      xAlign: "left",
      yAlign: "center",
      backgroundColor: "transparent",
      bodyFontColor: "#fff",
      bodyFontSize: 18,
      bodyFontFamily: "Inter, Helvetica, Arial, sans-serif",
      bodyFontStyle: "300",
    },
    layout: {
      padding: {
        right: 40
      }
    }
  },
};

// Persones residents
var configPersonesResidents = {
  type: "doughnut",
  data: {
    labels: ["El Nadal", "F. Gallifa"],
    datasets: [
      {
        data: [185, 51],
        backgroundColor: [white, grey1],
        borderWidth: 0,
      },
    ],
  },
  options: {
    maintainAspectRatio: false,  // Allow resizing by height/width
    responsive: true,  // Ensure chart is responsive
    tooltips: {
      enabled: false,
    },
    legend: {
      display: false,  // Display the legend
      // position: 'bottom',  // Position the legend at the bottom
      // labels: {
      //   fontColor: '#ffffff',  // Set the legend text color
      //   fontSize: 14,  // Set the legend text size
      //   usePointStyle: true,  // Use circles instead of rectangles
      // },
    },
  },
};

// Activitats fetes
var configActivitatsFetes = {
  type: "doughnut",
  data: {
    labels: ["El Nadal", "F. Gallifa"],
    datasets: [
      {
        data: [75, 69],
        backgroundColor: [white, grey1],
        borderWidth: 0,
      },
    ],
  },
  options: {
    maintainAspectRatio: false,  // Allow resizing by height/width
    responsive: true,  // Ensure chart is responsive
    tooltips: {
      enabled: false,
    },
    legend: {
      display: false,  // Display the legend
      // position: 'bottom',  // Position the legend at the bottom
      // labels: {
      //   fontColor: '#ffffff',  // Set the legend text color
      //   fontSize: 14,  // Set the legend text size
      //   usePointStyle: true,  // Use circles instead of rectangles
      // },
    },
  },
};

// Graus dependència - Nadal
var configGrausDepNadal = {
  type: "doughnut",
  data: {
    labels: ["Sense grau", "Grau I", "Grau II", "Grau III"],
    datasets: [
      {
        data: [3.78, 1.08, 67.57, 27.57],
        backgroundColor: [white, grey1, grey2, grey3],
        borderWidth: 0,
      },
    ],
  },
  options: {
    maintainAspectRatio: false,  // Allow resizing by height/width
    responsive: true,  // Ensure chart is responsive
    tooltips: {
      enabled: false,
    },
    legend: {
      display: false,  // Display the legend
      // position: 'bottom',  // Position the legend at the bottom
      // labels: {
      //   fontColor: '#ffffff',  // Set the legend text color
      //   fontSize: 14,  // Set the legend text size
      //   usePointStyle: true,  // Use circles instead of rectangles
      // },
    },
  },
};

// Graus dependència - Gallifa
var configGrausDepGallifa = {
  type: "doughnut",
  data: {
    labels: ["Sense grau", "Grau I", "Grau II", "Grau III"],
    datasets: [
      {
        data: [7.84, 5.88, 52.94, 33.33],
        backgroundColor: [white, grey1, grey2, grey3],
        borderWidth: 0,
      },
    ],
  },
  options: {
    maintainAspectRatio: false,  // Allow resizing by height/width
    responsive: true,  // Ensure chart is responsive
    tooltips: {
      enabled: false,
    },
    legend: {
      display: false,  // Display the legend
      // position: 'bottom',  // Position the legend at the bottom
      // labels: {
      //   fontColor: '#ffffff',  // Set the legend text color
      //   fontSize: 14,  // Set the legend text size
      //   usePointStyle: true,  // Use circles instead of rectangles
      // },
    },
  },
};

// Comunitària 01
var configComunitaria01 = {
  type: "horizontalBar",
  data: {
    labels: [
      "Persones usuàries",
      "Mitjana d'edat",
      "Activitats fetes",
    ],
    datasets: [
      {
        backgroundColor: [
          "#FFFFFF",
          "#FFFFFF",
          "#FFFFFF",
        ],
        data: [43, 84, 39],
        // barThickness: "flex",
        barThickness: "30",
        // categoryPercentage: 1.0,
        // barPercentage: 0.6,
      },
    ],
  },
  options: {
    title: {
      display: false,
    },
    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          display: false,
        },
      ],
      yAxes: [
        {
          display: true,
          gridLines: {
            display: false,
          },
          ticks: {
            fontColor: "#fff",
            fontFamily: "Inter, Helvetica, Arial, sans-serif",
            fontSize: 14,
            fontStyle: "400",
          },
        },
      ],
    },
    cornerRadius: 4,
    maintainAspectRatio: false,
    responsive: true,
    showAllTooltips: true,
    tooltips: {
      //mode: 'index',
      //intersect: false,
      callbacks: {
        titleFontSize: function () {
          return 200;
        },
        label: function (tooltipItem) {
          return tooltipItem.value;
        },
        title: function (tooltipItem) {
          return;
        },
      },
      displayColors: false,
      caretSize: 0,
      xAlign: "left",
      yAlign: "center",
      backgroundColor: "transparent",
      bodyFontColor: "#fff",
      bodyFontSize: 24,
      bodyFontFamily: "Inter, Helvetica, Arial, sans-serif",
      bodyFontStyle: "300",
    },
    layout: {
      padding: {
        right: 40
      }
    }
  },
};

// Comunitària 02
var configComunitaria02 = {
  type: "horizontalBar",
  data: {
    labels: [
      "Persones usuàries",
      "Mitjana d'edat",
      "Activitats fetes",
    ],
    datasets: [
      {
        backgroundColor: [
          "#FFFFFF",
          "#FFFFFF",
          "#FFFFFF",
        ],
        data: [27, 85, 34],
        // barThickness: "flex",
        barThickness: "30",
        // categoryPercentage: 1.0,
        // barPercentage: 0.6,
      },
    ],
  },
  options: {
    title: {
      display: false,
    },
    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          display: false,
        },
      ],
      yAxes: [
        {
          display: true,
          gridLines: {
            display: false,
          },
          ticks: {
            fontColor: "#fff",
            fontFamily: "Inter, Helvetica, Arial, sans-serif",
            fontSize: 14,
            fontStyle: "400",
          },
        },
      ],
    },
    cornerRadius: 4,
    maintainAspectRatio: false,
    responsive: true,
    showAllTooltips: true,
    tooltips: {
      //mode: 'index',
      //intersect: false,
      callbacks: {
        titleFontSize: function () {
          return 200;
        },
        label: function (tooltipItem) {
          return tooltipItem.value;
        },
        title: function (tooltipItem) {
          return;
        },
      },
      displayColors: false,
      caretSize: 0,
      xAlign: "left",
      yAlign: "center",
      backgroundColor: "transparent",
      bodyFontColor: "#fff",
      bodyFontSize: 24,
      bodyFontFamily: "Inter, Helvetica, Arial, sans-serif",
      bodyFontStyle: "300",
    },
    layout: {
      padding: {
        right: 40
      }
    }
  },
};

// Professionals 1
var configProfessionals1 = {
  type: "doughnut",
  data: {
    labels: ["Dones","Homes"],
    datasets: [
      {
        data: [89.33,10.67],
        backgroundColor: [green1,green3],
        borderWidth: 0,
      },
    ],
  },
  options: {
    maintainAspectRatio: false,  // Allow resizing by height/width
    responsive: true,  // Ensure chart is responsive
    tooltips: {
      enabled: false,
    },
    legend: {
      display: false,  // Display the legend
      // position: 'bottom',  // Position the legend at the bottom
      // labels: {
      //   fontColor: '#ffffff',  // Set the legend text color
      //   fontSize: 14,  // Set the legend text size
      //   usePointStyle: true,  // Use circles instead of rectangles
      // },
    },
  },
};

// Professionals 2
var configProfessionals2 = {
  type: "doughnut",
  data: {
    labels: ["Assistencials","No assistencials"],
    datasets: [
      {
        data: [83.85,16.15],
        backgroundColor: [green2,primary],
        borderWidth: 0,
      },
    ],
  },
  options: {
    maintainAspectRatio: false,  // Allow resizing by height/width
    responsive: true,  // Ensure chart is responsive
    tooltips: {
      enabled: false,
    },
    legend: {
      display: false,  // Display the legend
      // position: 'bottom',  // Position the legend at the bottom
      // labels: {
      //   fontColor: '#ffffff',  // Set the legend text color
      //   fontSize: 14,  // Set the legend text size
      //   usePointStyle: true,  // Use circles instead of rectangles
      // },
    },
  },
};

// Pressupost (amb tooltips)
// var configPressupost = {
//   type: "doughnut",
//   data: {
//     labels: ["Persones","Fàrmacs", "Material sanitari", "Serveis", "Altres despeses"],
//     datasets: [
//       {
//         data: [9949370.21, 269942.29, 264387.95, 4335252.11, 897181.91],
//         backgroundColor: [green1,green2,primary,green3,white],
//         borderWidth: 0,
//       },
//     ],
//   },
//   options: {
//     maintainAspectRatio: false,  // Allow resizing by height/width
//     responsive: true,  // Ensure chart is responsive
//     tooltips: {
//       callbacks: {
//         label: function (tooltipItem, data) {
//           var dataset = data.datasets[tooltipItem.datasetIndex];
//           var value = dataset.data[tooltipItem.index];

//           // Format number with dot for thousands and comma for decimals
//           var formattedValue = value
//             .toFixed(2) // Ensure two decimal places
//             .replace(/\D/g, ",") // Replace decimal point with a comma
//             .replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Add dots for thousand separators

//           return formattedValue + " €"; // Append Euro symbol
//         },
//       },
//     },
//     legend: {
//       display: true,  // Display the legend
//       position: 'bottom',  // Position the legend at the bottom
//       labels: {
//         fontColor: 'grey2',  // Set the legend text color
//         fontSize: 14,  // Set the legend text size
//         usePointStyle: true,  // Use circles instead of rectangles
//       },
//     },
//   },
// };

// Pressupost (sense tooltips)
var configPressupost = {
  type: "doughnut",
  data: {
    labels: ["Persones","Fàrmacs", "Material sanitari", "Serveis", "Altres despeses"],
    datasets: [
      {
        data: [9949370.21, 269942.29, 264387.95, 4335252.11, 897181.91],
        backgroundColor: [green1,green2,primary,green3,white],
        borderWidth: 0,
      },
    ],
  },
  options: {
    maintainAspectRatio: false,  // Allow resizing by height/width
    responsive: true,  // Ensure chart is responsive
    tooltips: {
      enabled: false,
    },
    legend: {
      display: false,
    },
  },
};

$(document).ready(function () {
  ("use strict");

  $("#chart-HUSCV")
    .parent()
    .viewportChecker({
      callbackFunction: function () {
        var ctx = document
          .getElementById("chart-HUSCV")
          .getContext("2d");
        window.myBar = new Chart(ctx, configHUSCV);
      },
    });
    $("#chart-persones-residents")
    .parent()
    .viewportChecker({
      callbackFunction: function () {
        var ctx = document
          .getElementById("chart-persones-residents")
          .getContext("2d");
        window.myBar = new Chart(ctx, configPersonesResidents);
      },
    });
    $("#chart-activitats-fetes")
    .parent()
    .viewportChecker({
      callbackFunction: function () {
        var ctx = document
          .getElementById("chart-activitats-fetes")
          .getContext("2d");
        window.myBar = new Chart(ctx, configActivitatsFetes);
      },
    });
    $("#chart-graus-dependencia-1")
    .parent()
    .viewportChecker({
      callbackFunction: function () {
        var ctx = document
          .getElementById("chart-graus-dependencia-1")
          .getContext("2d");
        window.myBar = new Chart(ctx, configGrausDepNadal);
      },
    });
    $("#chart-graus-dependencia-2")
    .parent()
    .viewportChecker({
      callbackFunction: function () {
        var ctx = document
          .getElementById("chart-graus-dependencia-2")
          .getContext("2d");
        window.myBar = new Chart(ctx, configGrausDepGallifa);
      },
    });
    $("#chart-comunitaria-01")
    .parent()
    .viewportChecker({
      callbackFunction: function () {
        var ctx = document
          .getElementById("chart-comunitaria-01")
          .getContext("2d");
        window.myBar = new Chart(ctx, configComunitaria01);
      },
    });
    $("#chart-comunitaria-02")
    .parent()
    .viewportChecker({
      callbackFunction: function () {
        var ctx = document
          .getElementById("chart-comunitaria-02")
          .getContext("2d");
        window.myBar = new Chart(ctx, configComunitaria02);
      },
    });
    $("#chart-professionals-1")
    .parent()
    .viewportChecker({
      callbackFunction: function () {
        var ctx = document
          .getElementById("chart-professionals-1")
          .getContext("2d");
        window.myDoughnut = new Chart(ctx, configProfessionals1);
      },
    });
    $("#chart-professionals-2")
    .parent()
    .viewportChecker({
      callbackFunction: function () {
        var ctx = document
          .getElementById("chart-professionals-2")
          .getContext("2d");
        window.myDoughnut = new Chart(ctx, configProfessionals2);
      },
    });
    $("#chart-pressupost")
    .parent()
    .viewportChecker({
      callbackFunction: function () {
        var ctx = document
          .getElementById("chart-pressupost")
          .getContext("2d");
        window.myDoughnut = new Chart(ctx, configPressupost);
      },
    });

});
